import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../components/loader/loader.service';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class LoaderinterceptorService implements HttpInterceptor {
  private requests: Map<HttpRequest<any>, Observable<HttpEvent<any>>> = new Map();

  constructor(private loaderService: LoaderService) {}

  private trackRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Show loader immediately
    this.loaderService.show();
    const observable = next.handle(req).pipe(
      catchError(err => {
        this.requests.delete(req);
        this.updateLoader();
        return throwError(err);
      }),
      finalize(() => {
        this.requests.delete(req);
        this.updateLoader();
      })
    );

    this.requests.set(req, observable);
    
    return observable;
  }

  private updateLoader() {
    if (this.requests.size === 0) {
      this.loaderService.hide();
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url && JSON.stringify(req.url).includes('ECPUser/GetProgramImage')) {
      return next.handle(req);
  }
    return this.trackRequest(req, next);
  }
}
